import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "template"]

    add(e) {
        e.preventDefault()
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.containerTarget.insertAdjacentHTML('beforeend', content)
    }

    remove(e) {
        e.preventDefault()
        const wrapper = e.target.closest(".nested-form-wrapper")
        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.style.display = "none"
            const destroyInput = wrapper.querySelector("input[name*='_destroy']")
            if (destroyInput) destroyInput.value = "1"
        }
    }
}
